import React, { useEffect, useState } from "react";
import { Organization } from "src/@types/ImpiricaPlatformApi";
import { useApi } from "src/Api/useApi";
import { Plus } from "lucide-react";
import { Icon } from "src/components/icons/Icon";
import { Tooltip } from "antd";
import DataTable from "src/components/common/DataTable";
import { IconButton } from "../buttons";

interface IProps {
	orgIdFilter: number[];
	onSelect: any;
}

export const OrgSelector = (props: IProps) => {
	const { orgIdFilter, onSelect } = props;
	const { organizationClient } = useApi();
	const [orgs, setOrgs] = useState<Organization[]>([]);

	useEffect(() => {
		_loadData();
	}, [orgIdFilter]);

	const _loadData = async () => {
		if (organizationClient) {
			const filteredOrgs = await organizationClient.getFilteredOrgs(
				orgIdFilter
			);
			setOrgs(filteredOrgs);
		}
	};

	const _onSelect = async (orgId: number) => {
		await onSelect(orgId);
	};

	const _getActions = (rowInfo: any) => {
		return (
			<div style={{ paddingLeft: 30 }}>
				<IconButton
					className="pl-0 btn-link"
					title={"Add Organization"}
					onClick={() => _onSelect(rowInfo.original.id)}
					disabled={false}
				>
					<Icon icon={Plus} />
				</IconButton>
			</div>
		);
	};

	const _getActiveCell = (rowInfo: any) => {
		return (
			<div style={{ paddingLeft: 25 }}>
				{rowInfo.original.isActive ? "Active" : "InActive"}
			</div>
		);
	};

	const _getColumns = () => {
		const columns = [
			{
				accessor: "id",
				show: false,
			},
			{
				Header: <Tooltip title="Organization Name">Organization</Tooltip>,
				accessor: "name",
				filterable: true,
			},
			{
				Header: <Tooltip title="Active">Active</Tooltip>,
				accessor: "isActive",
				filterable: true,
				Cell: (rowInfo: any) => {
					return _getActiveCell(rowInfo);
				},
				width: 100,
			},
			{
				Header: <Tooltip title="Actions">Actions</Tooltip>,
				accessor: "Actions",
				Cell: (rowInfo: any) => {
					return _getActions(rowInfo);
				},
				id: "Actions",
				filterable: false,
				width: 100,
			},
		];

		return columns;
	};

	return (
		orgs && (
			<DataTable
				data={orgs}
				columns={_getColumns()}
				filterable={true}
				defaultPageSize={5}
				defaultSorted={[{ id: "name", desc: false }]}
			/>
		)
	);
};
